import React, { useState } from 'react';
import {
    Box,
    Tabs,
    Tab,
    Typography,
    Paper,
} from '@mui/material';
import {
    Sync as SISIcon,
    School as UniversityIcon,
    Assessment as StatusIcon,
} from '@mui/icons-material';
import SISIntegration from '../SISIntegration/SISIntegration';
import { IntegrationManagement } from './index';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`integration-tabpanel-${index}`}
            aria-labelledby={`integration-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ pt: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const IntegrationsHub: React.FC = () => {
    const [currentTab, setCurrentTab] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setCurrentTab(newValue);
    };

    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                System Integrations
            </Typography>

            <Typography variant="body1" color="text.secondary" gutterBottom sx={{ mb: 3 }}>
                Manage connections to external systems and data sources
            </Typography>

            <Paper sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={currentTab}
                        onChange={handleTabChange}
                        aria-label="integration tabs"
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <Tab
                            icon={<SISIcon />}
                            label="SIS Integration"
                            iconPosition="start"
                            id="integration-tab-0"
                            aria-controls="integration-tabpanel-0"
                        />
                        <Tab
                            icon={<UniversityIcon />}
                            label="Universities"
                            iconPosition="start"
                            id="integration-tab-1"
                            aria-controls="integration-tabpanel-1"
                        />
                        <Tab
                            icon={<StatusIcon />}
                            label="System Status"
                            iconPosition="start"
                            id="integration-tab-2"
                            aria-controls="integration-tabpanel-2"
                        />
                    </Tabs>
                </Box>

                <TabPanel value={currentTab} index={0}>
                    <SISIntegration />
                </TabPanel>

                <TabPanel value={currentTab} index={1}>
                    <Box sx={{ p: 3 }}>
                        <Typography variant="h6" gutterBottom>
                            University Integrations
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Manage university data integrations (SUZA, etc.)
                        </Typography>
                        {/* University integration content will go here */}
                    </Box>
                </TabPanel>

                <TabPanel value={currentTab} index={2}>
                    <IntegrationManagement />
                </TabPanel>
            </Paper>
        </Box>
    );
};

export default IntegrationsHub;
